define('CartToQuote.Button.PDP.View', [
    'SCView',
    'carttoquote_button_pdp_view.tpl',
    'underscore'
], function CartToQuoteButtonPDPViewDefinition(
    SCViewComponent,
    cartToQuoteButtonPDPViewTpl,
    _
) {
    'use strict';

    var DEFAULT_SUCCESS_MESSAGE = '$(0) has been added to your Cart, you can convert it to a Quote now.<br />Quantity: $(1)';

    var SCView = SCViewComponent.SCView;

    var CartToQuoteButtonPDPView = function CartToQuoteButtonPDPView(options) {
        var self = this;

        SCView.call(this);

        this.template = cartToQuoteButtonPDPViewTpl;
        this.options = options || {};
        this.configuration = this.options.configuration;
        this.attributes = {
            id: 'CartToQuoteButtonPDPView',
            'class': 'CartToQuoteButton-View'
        };
        this.contextDataRequest = ['item'];

        this.pdp = this.options.container.getComponent('PDP');
        this.cart = this.options.container.getComponent('Cart');
        this.layout = this.options.container.getComponent('Layout');

        this.addToQuoteContext = {};
        this.pdp.on('addToQuoteOverride', function showCartToQuoteButton(addToQuoteContext) {
            self.addToQuoteContext = addToQuoteContext;
            self.render();
        });
    };

    // Inherit parent instance methods.
    CartToQuoteButtonPDPView.prototype = Object.create(SCView.prototype);

    // Restore the constuctor.
    CartToQuoteButtonPDPView.prototype.constructor = CartToQuoteButtonPDPView;

    CartToQuoteButtonPDPView.prototype.getTitle = function getTitle() {
        return _(this.options.pageInfo.title).translate();
    };

    CartToQuoteButtonPDPView.prototype.getEvents = function getEvents() {
        return {
            'click [data-type="add-to-quote"]': 'addToQuote'
        };
    };

    CartToQuoteButtonPDPView.prototype.addToQuote = function addToQuote(e) {
        var itemInfo = this.pdp.getItemInfo() || {};
        var matrixChilds = this.pdp.getAllMatrixChilds() || [];
        var selectedMatrixChilds = this.pdp.getSelectedMatrixChilds() || [];
        var item;
        var self = this;
        var message = {
            type: '',
            message: this.configuration.addToQuoteMessage || DEFAULT_SUCCESS_MESSAGE,
            selector: this.options.pageInfo.placeholder
        };

        if (matrixChilds.length) {
            item = selectedMatrixChilds.length === 1 ? selectedMatrixChilds[0] : {};
        } else {
            item = itemInfo.item || this.contextData.item();
        }

        this.cart.addLine({
            line: {
                quantity: itemInfo.quantity || 1,
                item: {
                    internalid: item.internalid
                }
            }
        }).then(
            function addLineSuccess() {
                message.type = 'success';
                message.message = _(message.message).translate(
                    item.keyMapping_name,
                    itemInfo.quantity || 1
                );
            },
            function addLineError(err) {
                message.type = 'error';
                message.message = err.responseJSON && err.responseJSON.errorMessage;
            }
        ).always(function afterAddLine() {
            self.layout.showMessage(message);
        });
        return e.preventDefault() || e.stopPropagation();
    };

    CartToQuoteButtonPDPView.prototype.getContext = function getContext() {
        return {
            isQuotable: Boolean(this.addToQuoteContext.isQuotable),
            isReadyForQuote: Boolean(this.addToQuoteContext.isReadyForQuote),
            buttonLabel: this.configuration.addToQuoteLabel || this.getTitle()
        };
    };

    // Return the AMD constructor.
    return CartToQuoteButtonPDPView;
});
